/**
 * Custom hook that detects whether an element is visible in the viewport using the Intersection Observer API.
 * @param ref - The ref object that points to the element to be observed.
 * @param options - Optional configuration options for the Intersection Observer.
 * @returns A boolean value indicating whether the observed element is currently intersecting with the viewport.
 */
import { useEffect, useState } from 'react';

export const useIsVisible = (ref: React.RefObject<HTMLElement>, options?: IntersectionObserverInit) => {
  const [ isIntersecting, setIntersecting ] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([ entry ]) => {
      setIntersecting(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    };
    return () => {
      observer.disconnect();
    };
  }, [ ref, options, ref.current ]);

  return isIntersecting;
};
